import AnnouncementTile from './AnnouncementTile';

export default AnnouncementTile;
